
import isPlainObject from 'lodash-es/isPlainObject';

import { getLocation } from './system';
import { createNormalizer } from './urlFactory';

/**
 * 删除参数值
 *
 * @param {string} url
 * @param {string|array} ref
 *
 * @return {string}
 */
export function delQueStr(url, ref) {
  let str = '';
  if (url.indexOf('?') !== -1) {
    str = url.substr(url.indexOf('?') + 1);
  } else {
    return url;
  }
  let arr = '';
  let returnurl = '';
  const isHit =    Object.prototype.toString.call(ref) === '[object Array]'
    ? function (v) {
      return ~ref.indexOf(v);
    }
    : function (v) {
      return v === ref;
    };
  if (str.indexOf('&') !== -1) {
    arr = str.split('&');
    for (let i = 0, len = arr.length; i < len; i++) {
      if (!isHit(arr[i].split('=')[0])) {
        returnurl = `${returnurl + arr[i].split('=')[0]}=${
          arr[i].split('=')[1]
        }&`;
      }
    }

    return returnurl
      ? `${url.substr(0, url.indexOf('?'))}?${returnurl.substr(
        0,
        returnurl.length - 1,
      )}`
      : url.substr(0, url.indexOf('?'));
  }
  arr = str.split('=');
  if (isHit(arr[0])) {
    return url.substr(0, url.indexOf('?'));
  }
  return url;
}

/**
 * 从URL中获取指定的参数值
 *
 * @param {String}
 *          p url参数
 * @param {String}
 *          u url 默认为当前url，可为空，如果传入该变量，将从该变量中查找参数p
 * @return {String} 返回的参数值
 */
export function getUrlParam(p, u) {
  const url = u || getLocation().href || '';

  if (!url) {
    return '';
  }

  const reg = new RegExp(`[?&#]${p}=([^&#]+)`, 'gi');

  const matches = url.match(reg);
  let strArr;
  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1].split('=');
    if (strArr && strArr.length > 1) {
      // 过滤XSS字符
      return filterXSS(strArr[1]);
    }
    return '';
  }
  return '';
}

/**
 *获取专辑角标url
 * @param imgTag：角标字段，一般取的是aphone40_imgtag字段，或返回格式同aphone40_imgtag字段
 * @returns {string} 要展示的角标url
 */
export function getCoverTag(imgTag) {
  const normalizer = createNormalizer();
  function format(tpl, data) {
    return tpl.replace(/\{(\w+)\}/g, (m, w) => {
      let val = (data[w] || '');
      if (val.indexOf(';') !== -1) {
        const _tags = val.split(';');
        const [, formatTag] = _tags;
        if (_tags.length >= 2 && formatTag) {
          val = formatTag;
        }
      }
      if (val.indexOf('=') !== -1) {
        const varArr = val.split('=');
        const [, formatVal] = varArr;
        if (varArr.length > 0 && formatVal) {
          val = formatVal;
        }
      }
      return /^(http:|https:|\/\/)/.test(val) ? normalizer(val, false, 'https') : val;
    });
  }

  function legalParam(paramText) {
    if ((/\.(\w+)$/.test(paramText))) {
      return true;
    }
    return false;
  }

  function indexOf(item, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (item === arr[i]) return i;
    }
    return -1;
  }

  let str = '';
  const positions = [2];
  let tag = imgTag;

  if (tag) {
    const tag2Tpl = '<img src="{param2}" alt="{text}">';
    // 先对tag进行处理，若为string类型的json则转换
    if (typeof tag === 'string') {
      try {
        tag = JSON.parse(tag);
      } catch (e) {}
    }
    // 出品类型：独播，腾讯出版
    if (tag.tag_2 && tag.tag_2.id > 0 && indexOf(2, positions) !== -1) {
      if (legalParam(tag.tag_2.param2)) {
        str += format(tag2Tpl, tag.tag_2);
      }
    }
  }
  return str;
}

/**
 * 设置url中指定的参数
 *
 * @param {string}
 *          name [参数名]
 * @param {string}
 *          value [参数值]
 * @param {string}
 *          url [发生替换的url地址|默认为location.href]
 * @return {string} [返回处理后的url]
 */
export function setUrlParam(name, value, url) {
  url = url || location.href;
  const reg = new RegExp(`[?&#]${name}=([^&#]*)`, 'gi');

  const matches = url.match(reg);

  let strArr;

  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1];
  } else {
    strArr = '';
  }

  const extra = `${name}=${value}`;

  // 当原url中含有要替换的属性:value不为空时，仅对值做替换,为空时，直接把参数删除掉
  if (strArr) {
    if (value) {
      const first = strArr.charAt(0);
      url = url.replace(strArr, first + extra);
    } else {
      url = delQueStr(url, name);
    }
  } else if (value) {
    const hashIndex = url.indexOf('#');
    let hash = '';
    if (hashIndex > -1) {
      hash = url.substring(hashIndex);
      url = url.substring(0, hashIndex);
    }
    // 当原url中不含有要替换的属性且value值不为空时,直接在url后面添加参数字符串
    if (url.indexOf('?') > -1) {
      url += `&${extra}`;
    } else {
      url += `?${extra}`;
    }

    url += hash;
  }
  // 其它情况直接返回原url
  return url;
}

/**
 * 过滤XSS
 *
 * @param {string}
 *          str
 * @return {}
 */
export function filterXSS(str) {
  return str
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/**
  * 统一定义Object.prototype.hasOwnProperty.call()
  */
export function hasOwn(foo, bar) {
  return Object.prototype.hasOwnProperty.call(foo, bar);
}

/**
 * 设置promise超时时间
 * https://advancedweb.hu/how-to-add-timeout-to-a-promise-in-javascript/
 * @param {Number} milliseconds
 * @param {Promise} promise
 * @param {*} exception
 * @returns Promise
 */
export function promiseTimeout(promise, milliseconds, exception = new Error('promise timeout')) {
  let timer;
  return Promise.race([
    promise,
    new Promise((_r, reject) => timer = setTimeout(reject, milliseconds, exception)),
  ])
    .finally(() => clearTimeout(timer));
}

/**
 * 加载script脚本
 * @param {string} url
 * @param {Object} options 可选参数
 * @param {String} options.id 可选：scriptId
 * @param {Boolean} options.clearMode 可选：是否移除script
 * @param {Boolean} options.injectParent 可选：是否在父级注入
 * @param {Number} options.timeout 可选：是否在父级注入
 * @returns {Promise}
 */
export function loadScript(...args) {
  if (args.length === 1 || (typeof args[0] === 'string' && isPlainObject(args[1]))) {
    return doLoadScript(...args);
  }

  return loadScript2(...args);
};
/**
 * @duplicate
 * 动态加载JS文件
 * @param  {string}   id       [description]
 * @param  {string}   url      [description]
 * @param  {Function} callback [description]
 * @return {Promise}           [description]
 */
export function loadScript2(id, url, callback) {
  const target = document.getElementById(id);
  if (target) {
    return new Promise((resolve) => {
      resolve();
      callback && callback();
    });
  }
  return doLoadScript(url, { id, clearMode: false }).then(() => {
    callback && callback();
  });
};
export function doLoadScript(url, { clearMode = true, injectParent = false, timeout = 5000, id } = {}) {
  let doc = document;
  // 支持在父级注入，要求页面处理同域或者降域处理
  if (injectParent && top !== window) {
    try {
      doc = top.document;
    } catch (e) {
      console.error('use parent document caught error', e);
    }
  }

  const script = doc.createElement('script');
  script.stype = 'text/javascript';
  if (id) {
    script.id = id;
  }
  const insertPoint = doc.getElementsByTagName('script')[0];
  insertPoint.parentNode.insertBefore(script, insertPoint);

  return new Promise((resolve, reject) => {
    let timer;
    if (timeout > 0) {
      timer = setTimeout(() => {
        reject(new Error(`loadScript '${url}' timeout over ${timeout}`));
      }, timeout);
    }
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          timer && clearTimeout(timer);
          resolve();
          if (clearMode) {
            script.parentNode.removeChild(script);
          }
        }
      };
    } else {
      script.onload = function () {
        timer && clearTimeout(timer);
        resolve();
        if (clearMode) {
          script.parentNode.removeChild(script);
        }
      };
      script.onerror = function () {
        timer && clearTimeout(timer);
        reject(new Error(`Script load fail: ${url}`));
      };
      script.onabort = function () {
        timer && clearTimeout(timer);
        reject(new Error(`Script load abort: ${url}`));
      };
    }
    script.src = url;
  });
};

export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
